export enum storageKey {
  GAMES_RESENT_KEYWORD = "games_resent_keyword",
  ATH_RESENT_KEYWORD = "ath_resent_keyword",
}
